import type { WallDefinition } from "./wallDefinitions";
import { HG_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";

export const HG_WALL_DEFINITION: WallDefinition = {
  id: "hg-wall",
  firstClearReward: HG_WALL_BALANCE_PROFILE.firstClearReward,
};

// HG Wall — Wall7. While active, the normally computed HG is weakened by
// `(baseHg / HG_WALL_CONSTRAINT_HG_DIVISOR) ** HG_WALL_CONSTRAINT_HG_EXPONENT`.
// The constraint values and the clear reward profile stay HG-Wall-specific so
// they remain independently tunable from Freshness / other walls. The clear
// reward composes additively into the BHG -> HG power exponent via the typed
// `add` effect on the `bhg-to-hg-power-exponent-bonus` dimension, alongside the
// skill-side `hov-hg-exponent-bonus`.
export const HG_WALL_CONSTRAINT_HG_DIVISOR =
  HG_WALL_BALANCE_PROFILE.challenge.hgDivisor;
export const HG_WALL_CONSTRAINT_HG_EXPONENT =
  HG_WALL_BALANCE_PROFILE.challenge.hgExponent;

export const HG_WALL_REWARD_TARGET_CLEAR_MS =
  HG_WALL_BALANCE_PROFILE.reward.targetClearMs;
export const HG_WALL_REWARD_EXPONENT_BONUS_BASE =
  HG_WALL_BALANCE_PROFILE.reward.baseExponentBonus;
export const HG_WALL_REWARD_EXPONENT_BONUS_MIN =
  HG_WALL_BALANCE_PROFILE.reward.minimumExponentBonus;
export const HG_WALL_REWARD_EXPONENT_BONUS_MAX =
  HG_WALL_BALANCE_PROFILE.reward.caps.base;
export const HG_WALL_REWARD_EXPONENT_BONUS_FALLOFF =
  HG_WALL_BALANCE_PROFILE.reward.falloff;

export function resolveHgWallRewardEffectiveMaxExponentBonus(): number {
  return HG_WALL_REWARD_EXPONENT_BONUS_MAX;
}

export function resolveHgWallRewardExponentBonus(
  bestClearMs: number | null,
  effectiveMaxExponentBonus: number = resolveHgWallRewardEffectiveMaxExponentBonus(),
): number {
  if (bestClearMs === null) return 0;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return effectiveMaxExponentBonus;
  }

  const bestSeconds = bestClearMs / 1000;
  const targetSeconds = HG_WALL_REWARD_TARGET_CLEAR_MS / 1000;
  const raw =
    HG_WALL_REWARD_EXPONENT_BONUS_BASE *
    (targetSeconds / bestSeconds) ** HG_WALL_REWARD_EXPONENT_BONUS_FALLOFF;

  if (!Number.isFinite(raw)) {
    return effectiveMaxExponentBonus;
  }

  return Math.min(
    effectiveMaxExponentBonus,
    Math.max(HG_WALL_REWARD_EXPONENT_BONUS_MIN, raw),
  );
}
